<template>
  <div class="offline-meeting-request-template" theme>
    <div id="offline-meeting-request-content" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'offline-meeting',
      parts: [
        {
          elem: '#offline-meeting-request-content',
          htmlFile: 'request'
        }
      ]
    }
  }
}
</script>
